import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LoggerService } from '@careapp/angular-sdk';
import { AppSettings } from '../settings/app-settings.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(fb, logger, settings) {
        this.fb = fb;
        this.logger = logger;
        this.settings = settings;
        this._disabled = false;
        this._loading = false;
        this.email = new FormControl('', Validators.compose([Validators.required]));
        this.password = new FormControl('', Validators.compose([
            Validators.required,
            Validators.minLength(this.settings.MIN_PASSWORD_LENGTH),
            Validators.maxLength(this.settings.MAX_DEFAULT_LENGTH)
        ]));
        this.login = new EventEmitter();
        this.form = this.createForm();
    }
    Object.defineProperty(LoginComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (val) {
            this._loading = val;
            if (this._loading && !this.form.disabled) {
                this.form.disable();
            }
            else if (!this._loading && !this._disabled && this.form.disabled) {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.ngOnInit = function () {
        this.logger.log('in login');
    };
    LoginComponent.prototype.createForm = function () {
        return this.fb.group({ email: this.email, password: this.password });
    };
    LoginComponent.prototype.submit = function (form) {
        this.logger.log('emit submission');
        if (this.form.invalid)
            return false;
        if (this.loading)
            return false;
        if (this.disabled)
            return false;
        this.login.emit(form);
        return false;
    };
    return LoginComponent;
}());
export { LoginComponent };
